<template>
  <div>
    <!-- 詢價需求單查詢 -->
    <CCard class="w-100">
      <CCardHeader>
        <strong>詢價需求單</strong>
      </CCardHeader>
      <CCardBody>
        <CForm>
          <div class="CForminline">
            <div class="quotation_class" v-if="!isMember">
              <p>{{ $t("QuoteInfo_Vue.FactoryType") }}：</p>
              <div
                v-for="(item, key) in factoryList"
                :key="'factoryType_input_' + key"
              >
                <input
                  type="radio"
                  :name="'coa_FactoryTypeOpt'"
                  v-model="searchParam.Factory"
                  :value="item.factoryId"
                />{{ getFactoryCaption(item.factoryId, item.factoryCaption) }}
              </div>
            </div>
            <div class="date_range">
              <p>{{ $t("SearchBar_Vue.StartDateBeginText") }}：</p>
              <div>
                <date-picker
                  :lang="'zh-tw'"
                  v-model="searchParam.CreateTimeStart"
                  format="YYYY-MM-DD"
                  valueType="format"
                ></date-picker>
                <span>~</span>
                <date-picker
                  :lang="'zh-tw'"
                  v-model="searchParam.CreateTimeEnd"
                  format="YYYY-MM-DD"
                  valueType="format"
                  :disabled-date="
                    (date) =>
                      date.addDays(1, 'day') <=
                      new Date(searchParam.CreateTimeStart)
                  "
                ></date-picker>
              </div>
            </div>

            <div class="number_range">
              <p>{{ $t("Request_Vue.QuoteNoIntervalText") }}：</p>
              <input
                type="text"
                maxlength="12"
                v-model="searchParam.InquiryNoStart"
                @change="checkInquiryNo"
              />
              <span>~</span>
              <input
                type="text"
                maxlength="12"
                v-model="searchParam.InquiryNoEnd"
                @change="checkInquiryNo"
              />
            </div>

            <div class="inquiry_name">
              <p>{{ $t("Request_Vue.InquiryName") }}：</p>
              <input
                type="text"
                maxlength="15"
                v-model="searchParam.InquiryName"
              />
            </div>

            <div class="Applicant">
              <p>{{ $t("Request_Vue.Applicant") }}：</p>
              <input
                type="text"
                maxlength="15"
                v-model="searchParam.ApplicantName"
              />
            </div>

            <div class="applicant_unit">
              <p>{{ $t("Request_Vue.ApplicantDept") }}：</p>
              <input
                type="text"
                maxlength="15"
                v-model="searchParam.ApplicantDept"
              />
            </div>

            <div class="purchase">
              <p>{{ $t("Request_Vue.Purchaser") }}：</p>
              <input
                type="text"
                maxlength="15"
                v-model="searchParam.Purchase"
              />
            </div>

            <div class="status_code">
              <p>{{ $t("Request_Vue.Status") }}：</p>
              <div
                v-for="(item, key) in statusCodeList"
                :key="'statusCode_input_' + key"
              >
                <input
                  type="radio"
                  name="statusCode_input"
                  v-model="searchParam.Status"
                  :value="item.statusCodeId"
                />{{ item.statusCodeCaption }}
              </div>
            </div>

            <div class="closure">
              <p>{{ $t("Request_Vue.isPR") }}：</p>
              <div
                v-for="(item, key) in isPRList"
                :key="'caseClosed_input_' + key"
              >
                <input
                  type="radio"
                  name="caseClosed_input"
                  v-model="searchParam.isPR"
                  :value="item.isPRId"
                />{{ item.isPRCaption }}
              </div>
            </div>

            <div class="btn_group">
              <button
                type="button"
                class="btn btn-edit mr-2"
                @click="searchDataEvent"
              >
                {{ $t("Buttons.Query") }}
              </button>
              <button type="button" class="btn btn-success mr-2" @click="goAdd">
                {{ $t("Buttons.AddNew") }}
              </button>
              <button
                type="button"
                class="btn btn-info mr-2"
                @click="exportSummary"
                v-if="isPurchase"
              >
                {{ $t("Buttons.ExportSummary") }}
              </button>
              <button
                type="button"
                class="btn btn-info mr-2"
                @click="exportDetail"
              >
                {{ $t("Buttons.ExportDetail") }}
              </button>
            </div>
          </div>
        </CForm>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      searchParam: {
        Factory: "",
        CreateTimeStart: "",
        CreateTimeEnd: "",
        InquiryNoStart: "",
        InquiryNoEnd: "",
        InquiryName: "",
        ApplicantName: "",
        ApplicantDept: "",
        Purchase: "",
        Status: "",
        isPR: "",
      },
      statusCodeList: this.$t("statusCodeList"), //狀態碼 清單
      isPRList: this.$t("isPRList"), //是否回填請購單 清單
      factoryList: this.$t("factoryRrquestSearchList"), //廠別 清單

      isPurchase: null, // 是否為採購身分(所有採購)
    };
  },
  props: {},
  watch: {
    lang: function () {
      this.statusCodeList = this.$t("statusCodeList"); //狀態碼 清單
      this.isPRList = this.$t("isPRList");
      this.factoryList = this.$t("factoryRrquestSearchList"); //廠別 清單
    },
  },
  mounted() {
    const filter = this.$store.getters["requestModule/requestSearchObj"].filter;
    if (filter) {
      Object.assign(this.searchParam, filter);
    }

    this.searchDataFirst(filter);
  },
  computed: {
    ...mapGetters(["lang"]),
  },
  methods: {
    goAdd() {
      sessionStorage.setItem("requestMasterId", "");
      this.$router.push({ path: "/requestedit", query: { formStatus: "new" } });
    },
    checkInquiryNo() {
      if (this.searchParam.InquiryNoStart > this.searchParam.InquiryNoEnd) {
        this.searchParam.InquiryNoEnd = "";
      }
    },
    //檢核條件
    checkSearchParam() {
      const {
        CreateTimeStart,
        CreateTimeEnd,
        DeadlineBegin,
        DeadlineEnd,
        InquiryNoStart,
        InquiryNoEnd,
      } = this.searchParam;
      let errMsg = "";
      if (CreateTimeStart && CreateTimeEnd) {
        if (CreateTimeStart > CreateTimeEnd) {
          errMsg = "開單日期區間錯誤，起始日不得大於終止日!";
        }
      }
      if (DeadlineBegin && DeadlineEnd) {
        if (DeadlineBegin > DeadlineEnd) {
          errMsg = "截止日期區間錯誤，起始日不得大於終止日!";
        }
      }
      if (InquiryNoStart && InquiryNoEnd) {
        if (InquiryNoStart > InquiryNoEnd) {
          errMsg = "單號區間錯誤，起始單號不得大於終止單號!";
        }
      }
      if (errMsg) {
        this.$alert(errMsg, "警告", { type: "warning" });
        return false;
      }
      return true;
    },

    // 進頁面顯示搜尋
    searchDataFirst(filter) {
      let roleId = this.$userInfo.roleId;
      let userFactory = this.$userInfo.userFactory;
      let accountName = this.$userInfo.accountName;
      let funcNames = this.$userInfo.funcNames;

      if (roleId.indexOf("採購") > -1 && !funcNames.some(str => str.includes("採購主管")) && !funcNames.some(str => str.includes("稽核主管")) && !funcNames.some(str => str === "詢價")) {
        // 是採購
        this.isPurchase = true;
        this.searchParam = {
          ...this.searchParam,
          Factory: filter.Factory ? filter.Factory : (filter.Factory === "" ? "" : (userFactory ? userFactory : "")),
          Purchase: filter.Purchase ? filter.Purchase : (filter.Purchase === "" ? "" : (accountName ? accountName : "")),
          Status: filter.Status ? filter.Status : (filter.Status === "" ? "" : "需求單位已確認"),
        };
      } else if (roleId === "詢價") {
        // 是詢價
        this.isPurchase = true;
        this.searchParam = {
          ...this.searchParam,
          Factory: filter.Factory ? filter.Factory : "",
        };
      } else {
        // 非採購或詢價
        this.isPurchase = false;
        this.searchParam = {
          ...this.searchParam,
          Factory: filter.Factory
            ? filter.Factory
            : filter.Factory === ""
            ? ""
            : userFactory
            ? userFactory
            : "",
        };
      }
    },

    //按鈕呼叫查詢觸發事件
    searchDataEvent() {
      if (!this.checkSearchParam()) {
        return;
      }
      if (!this.searchParam.InquiryNoEnd) {
        this.searchParam.InquiryNoEnd = this.searchParam.InquiryNoStart;
      }

      let roleId = this.$userInfo.roleId;

      if (roleId.indexOf("採購") > -1 || roleId === "詢價") {
        // 是採購或詢價
        this.isPurchase = true;
        this.searchParam = {
          ...this.searchParam,
        };
        this.$emit("doSearchEvent", this.searchParam);
      } else {
        // 非採購或詢價
        this.isPurchase = false;
        this.searchParam = {
          ...this.searchParam,
        };
        this.$emit("doSearchEvent", this.searchParam);
      }

      // this.searchData();
    },
    // searchData() {
    //     //須用此方式提供 語系對應功能函數
    //     this.searchParam.func = (key) => this.$t(key);
    //     this.searchParam.fixDate = this.fixDate;
    //     this.searchPurchase(this.searchParam);
    // },
    //匯出彙總表
    exportSummary() {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/MasterDataExport`;
      const params = {
        ...vm.searchParam,
      };
      this.updateLoading(true);
      vm.axios.get(api, { params, responseType: "blob" }).then((response) => {
        // console.log("匯出彙總表", response);
        if (response.data.type === "application/json") {
          let reader = new FileReader();
          reader.readAsText(response.data, "utf-8");
          reader.onload = () => {
            const { ErrorMessage } = JSON.parse(reader.result);
            this.updateLoading(false);
            Notification({
              title: "警告",
              message: ErrorMessage,
              type: "warning",
              duration: 5000,
            });
          };
        } else {
          this.updateLoading(false);

          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.href = url;
          a.download = "彙總表.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },

    //匯出明細表
    exportDetail() {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/DetailDataExport`;
      const params = {
        ...vm.searchParam,
      };
      this.updateLoading(true);
      vm.axios.get(api, { params, responseType: "blob" }).then((response) => {
        // console.log("匯出明細表", response);
        if (response.data.type === "application/json") {
          let reader = new FileReader();
          reader.readAsText(response.data, "utf-8");
          reader.onload = () => {
            const { ErrorMessage } = JSON.parse(reader.result);
            this.updateLoading(false);
            Notification({
              title: "警告",
              message: ErrorMessage,
              type: "warning",
              duration: 5000,
            });
          };
        } else {
          this.updateLoading(false);

          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.href = url;
          a.download = "明細表.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.CForminline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  > .form-group {
    margin-bottom: 0;
  }

  > .date_range,
  .number_range,
  .quotation_class,
  .inquiry_name,
  .Applicant,
  .applicant_unit,
  .purchase,
  .status_code,
  .closure {
    display: flex;
    align-items: center;
    margin: 0.5rem 0;
    > p {
      margin-right: 1rem;
      margin-bottom: 0;
    }
    > .purchase_input {
      margin-bottom: 0;
    }
    > input {
      margin: 0 0.5rem;
    }
    > div {
      margin: 0 0.5rem;
    }
  }
}

.purchase {
  width: 100%;
}

.btn-edit {
  background-color: #343b55;
  color: white;
}

@media screen and (max-width: 575px) {
  .CForminline {
    > .date_range,
    .number_range,
    .quotation_class,
    .inquiry_name,
    .Applicant,
    .applicant_unit,
    .purchase,
    .status_code,
    .closure {
      display: block;
      width: 100%;
      > input {
        width: 100%;
        margin: 0;
      }
      > div {
        margin: 0;
      }
      .mx-datepicker {
        width: 100%;
      }
    }
  }
}
</style>
